<template>
  <div class="p-12">
    <div class="max-w-7xl mx-auto">
      <div class="space-y-16">
        <div class="space-y-8">
          <div v-if="loading" class="px-4 text-center">
            <Loader />
          </div>

          <BaseGrid v-else :columns="3">
            <template v-for="channel in channels">
              <ChannelCard :key="channel.id" :entity="channel" />
            </template>
          </BaseGrid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectChannelsClient } from '@/api/clients';
import { middleware } from '@/routes/guards';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import ChannelCard from './ads/components/ChannelCard.vue';

export default {
  components: {
    ChannelCard,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      channels: [],
    };
  },
  beforeRouteEnter: middleware('account-permission:read channels'),
  created() {
    this.getChannels();
  },
  methods: {
    async getChannels() {
      this.loading = true;
      try {
        const response = await projectChannelsClient.list(this.projectId, {
          params: {
            inlcude: 'page',
          },
        });

        this.channels = mapKeysToCamelCase(response.data?.data || [], true);
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    changePage(page) {
      const { currentRoute } = this.$router;

      this.$router.push({
        ...currentRoute,
        query: {
          page,
        },
      });
    },
  },
};
</script>
